module.exports = "mutation adjustCredits($credit:CreditInput!,$userId:ID!,$type:String){adjustCredits(credit:$credit,userId:$userId,type:$type)}"